export enum DoMerge {
  Merge = 'Merge',
  Import = 'Import'
}
